var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-data",on:{"click":_vm.click}},[(_vm.column.title)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.column.title))]):_vm._e(),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.parseDate(_vm.row[_vm.column.field])))])])
}
var staticRenderFns = []

export { render, staticRenderFns }